import { useEffect, useRef } from 'react';
import gsap from 'gsap';

import useLoaderStore from '@/stores/useLoaderStore';

import './Loader.scss';

const Loader = () => {
    const loaderRef = useRef<HTMLDivElement>(null);

    const loading = useLoaderStore((state) => state.loading);

    useEffect(() => {
        const tl = gsap.timeline();

        tl.to(loaderRef.current, {
            duration: 0.3,
            opacity: loading ? 1 : 0,
            delay: 0.3,
        });

        tl.to(loaderRef.current, {
            display: loading ? 'block' : 'none',
        });
    }, [loading]);

    return (
        <div ref={loaderRef} className='loader'>
            <svg className='spinner' viewBox='0 0 50 50'>
                <circle
                    className='path'
                    cx='25'
                    cy='25'
                    r='20'
                    fill='none'
                    strokeWidth='5'
                ></circle>
            </svg>
        </div>
    );
};
export default Loader;
